// extracted by mini-css-extract-plugin
module.exports = {"container":"pollingStations_container__3R5-8"};